import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class WhenScrolledPast extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  async mount () {

    if (this._options.enableWhen && !this._addedListener) {
      window.addEventListener('resize', e => {
        if (matchMedia(`only screen and ${this._options.enableWhen}`).matches && !this._isMounted) {
          this.mount()
        } else if(!matchMedia(`only screen and ${this._options.enableWhen}`).matches && this._isMounted) {
          this.unmount()
          this._isMounted = false
        }
      }, { passive: true })
      this._addedListener = true
    }

    if (this._options.enableWhen && !matchMedia(`only screen and ${this._options.enableWhen}`).matches) {
      return false
    }

    if (this._options.length) {
      for (let option of this._options) {
        window.addEventListener('scroll', e => {
          this._scrollLogic(option)
        }, { passive: true })
      }
    } else {
      window.addEventListener('scroll', e => {
        this._scrollLogic(this._options)
      }, { passive: true })
    }
    
  }

  _scrollLogic (option, e) {
    let target = document.querySelector(option.selector);
    if ((window.scrollY > (target.offsetTop + target.offsetHeight)) && !Helpers.isInViewport(target)) {
        this._elem.classList.add(option.class)
    } else {
      this._elem.classList.remove(option.class)
    }
  }
}